const LockerIcon = ({ width = "16", height = "16" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width={width}
    height={height}
  >
    <path
      fill="currentColor"
      d="M15 1H1v1h14V1Zm0 13H1v1h14v-1ZM7 5H2v1h5V5Zm7 0H8v1h6V5ZM7 9H2v1h5V9Zm7 0H8v1h6V9ZM4 3H3v1h1V3Zm6 0H9v1h1V3ZM4 7H3v1h1V7Zm6 5H9v1h1v-1Zm-6 0H3v1h1v-1ZM2 2H1v12h1V2Zm13 0h-1v12h1V2ZM8 2H7v12h1V2Z"
    />
  </svg>
);

export default LockerIcon;
